import React from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";

import "./style.css";

function Home(){
    return(
      <>
        <Navbar />
        <Hero />
      </>  
    );
}

export default Home;